<template>
  <!-- eslint-disable vue/require-component-is -->
  <component v-bind="linkProps(to)" class="tamara-link">
    <slot />
  </component>
</template>

<script>
import { isExternal } from '@/utils/validate'

export default {
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  methods: {
    linkProps(url) {
      if (isExternal(url)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener',
        }
      }
      return {
        is: 'router-link',
        to: url,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tamara-link {
  display: flex;
  gap: 2px;
  align-items: center;
  color: #4a0089;
  text-decoration: underline;
  text-decoration-thickness: 0;
  text-decoration-color: #4a0089;
  text-underline-offset: 0;
  text-decoration-skip-ink: true;
}
</style>
